export function getDbValue() {
  let dbValue;
  if (import.meta.env.REACT_APP_BASE_URL.includes("test")) {
    dbValue = 3;
  } else if (import.meta.env.REACT_APP_BASE_URL.includes("staging")) {
    dbValue = 2;
  } else {
    dbValue = 1;
  }

  return dbValue; // Return the db value
}
